import { Active } from "./icons/Active";
import { Logout } from "@/svg/Logout";

export const UsersSettingsTabs = {
  active: "BI accounts",
  inactive: "Foodics accounts",
} as const;
export type UsersSettingsTab = (typeof UsersSettingsTabs)[keyof typeof UsersSettingsTabs];

export const TabIcons = {
  [UsersSettingsTabs.active]: Active,
  [UsersSettingsTabs.inactive]: Logout,
} as const;
